export const FEATURE_FLAG_STANDALONE_PROVISIONING = 'standalone-provisioning'
export const FEATURE_FLAG_FACTSET_AUTH = 'irwin-factset-auth'
